// extracted by mini-css-extract-plugin
export default {"HeaderButton":"style_HeaderButton__Mnuw-","newMember":"style_newMember__P7Mq1"};